import React from 'react'
import { Row, Col } from 'antd'

const Referer = () => {
   
    return (
        <Row className="camera-bar">
            <Col span={24}>
               
            </Col>
        </Row>
    )
}

export default Referer